/* SevenDayJourney — generic 8-step validation flow + the selected record's own 7-day plan. */
import React from 'react';
import { CheckCircle2 } from 'lucide-react';

const STEPS = [
  'Identify the target customer.',
  'Check local competitors and prices.',
  'Collect two current supplier quotations.',
  'Create a small safe sample or pilot.',
  'Obtain real customer feedback.',
  'Run a limited paid test.',
  'Record sales, costs, wastage and repeat interest.',
  'Continue, modify or stop based on evidence.',
];

export default function SevenDayJourney({ selected }) {
  const vj = selected?.validationJourney;
  const plan = selected?.journey?.sevenDayValidationPlan;
  return (
    <div className="space-y-4" data-testid="v20-seven-day">
      <ol className="grid sm:grid-cols-2 lg:grid-cols-4 gap-2">
        {STEPS.map((s, i) => (
          <li key={i} className="rounded-xl border border-emerald-200 bg-emerald-50/60 px-3 py-2 flex gap-2 text-xs text-gray-800">
            <span className="w-5 h-5 rounded-full bg-emerald-600 text-white text-[10px] font-bold flex items-center justify-center shrink-0">{i + 1}</span>{s}
          </li>
        ))}
      </ol>
      <p className="text-xs text-rose-800 bg-rose-50 border border-rose-200 rounded-xl px-3 py-2 font-semibold">Do not make a large investment before completing this validation stage.</p>
      {selected && (
        <div className="rounded-2xl border border-gray-200 bg-white p-4" data-testid="v20-seven-day-selected">
          <p className="text-[10px] uppercase tracking-widest font-bold text-gray-500">Plan for</p>
          <h4 className="font-extrabold text-gray-900">{selected.title}</h4>
          {vj?.first7Days && (
            <ul className="mt-3 space-y-1.5">{vj.first7Days.map((d, i) => <li key={i} className="flex gap-2 text-xs text-gray-800"><CheckCircle2 size={13} className="text-emerald-600 shrink-0 mt-0.5" />{d}</li>)}</ul>
          )}
          {plan && (
            <ul className="mt-3 space-y-2">{plan.map((d, i) => (
              <li key={i} className="text-xs text-gray-800"><strong>Day {d.day}: {d.goal}</strong>
                <ul className="list-disc pl-5 mt-0.5 space-y-0.5">{(d.actions || []).map((a, k) => <li key={k}>{a}</li>)}</ul>
                {d.proof && <p className="text-[11px] text-gray-500 mt-0.5">Proof: {d.proof}</p>}
              </li>
            ))}</ul>
          )}
          {(vj?.passGate || selected.journey?.evidenceGate) && (
            <div className="grid sm:grid-cols-2 gap-2 mt-3 text-xs">
              <div className="rounded-xl bg-emerald-50 border border-emerald-200 px-3 py-2"><strong className="text-emerald-800">Continue if:</strong> {vj?.passGate || selected.journey?.evidenceGate}</div>
              <div className="rounded-xl bg-rose-50 border border-rose-200 px-3 py-2"><strong className="text-rose-800">Stop / redesign if:</strong> {vj?.stopGate || (selected.journey?.stopOrPivotRules || []).join(' ')}</div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
